import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import ErrorIcon from '@mui/icons-material/Error';

interface AlertErrorDialogProps {
    open: boolean;
    errorMessage: string;
    onClose: () => void;
}

const AlertErrorDialog: React.FC<AlertErrorDialogProps> = ({ open, errorMessage, onClose }) => {
    const theme = useTheme();
    const colors = theme.palette;

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    backgroundColor: colors.modal.bg,
                    color: colors.modal.text,
                    border: `1px solid ${colors.inputNew.removeIcon}`
                }
            }}
        >
            <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, backgroundColor: colors.modal.bg}}>
                <ErrorIcon sx={{ color: colors.inputNew.removeIcon }} />
                Alert Configuration Error
            </DialogTitle>
            <DialogContent sx={{ backgroundColor: colors.modal.bg, color: colors.modal.text, paddingTop:'16px !important' }}>
                <Typography sx={{ color: colors.modal.text }}>{errorMessage}</Typography>
            </DialogContent>
            <DialogActions sx={{ backgroundColor: colors.modal.bg }}>
                <Button onClick={onClose} variant="contained" sx={{ backgroundColor: colors.buttons.primary.deleteButtonBg, color: colors.inputNew.saveText }}>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AlertErrorDialog;
